import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';
import AreaSplineChartWithHeader from './../../component/areaSplineChartWithHeader'
import Select from './../../component/select/';
import Utils from './../../component/utils/utils';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false,
        selectedInterval: 60,
    }

    componentDidMount () {
        Service.event.onFetchRevenuePerDayChartData.add((data) => {
            this.setState({
                renderChart : true,
                responseTableData: data,
                histogramChartCategoriesList: data.chartData.categoryList,
                histogramChartSeriesDataList1: data.chartData.seriesDataList1
            });
        });

        Service.fetchRevenueStatsByDay(60);
    }

    componentWillUnmount() {

    }

    constructor() {
        super();
        // setting default attribute values
        this.intervalOptions = Utils.intervalOptions;
    }

    selectElementChange = (event) => {
        this.setState({ selectedInterval: event.target.value});
        Service.fetchRevenueStatsByDay(event.target.value);
    };

    // refresh button actions
    searchButtonAction = () => {
        Service.fetchRevenueStatsByDay(this.state.selectedInterval);
    };

    render() {
        return (
            <div>
                <div className="graph-width">
                    { this.state.renderChart ? <AreaSplineChartWithHeader
                        chartTitle = {"Revenue For The Last " + this.state.selectedInterval + " days"}
                        histogramChartCategoriesList = {this.state.histogramChartCategoriesList}
                        histogramChartSeriesDataList = {
                            [{name : "Revenue",
                                data : this.state.histogramChartSeriesDataList1
                            }]
                        }
                        selectElementChange = {this.selectElementChange}
                        searchButtonAction = {this.searchButtonAction}
                        selectDropdownValues = {this.intervalOptions}
                        yAxisTitle = "Revenue Per Day"
                        headerIconClass = "fa fa-credit-card"
                        dolarSignFormat = "true"
                    /> : '' }
                </div>
            </div>
        );
    }
}

export default ChartView;